import { render, staticRenderFns } from "./CampaignSidebar.vue?vue&type=template&id=681fe416&scoped=true&"
import script from "./CampaignSidebar.vue?vue&type=script&lang=js&"
export * from "./CampaignSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSidebar.vue?vue&type=style&index=0&id=681fe416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fe416",
  null
  
)

export default component.exports